import { render, staticRenderFns } from "./VAdministrationSecondaryTable.vue?vue&type=template&id=1cf53255&"
import script from "./VAdministrationSecondaryTable.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationSecondaryTable.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationSecondaryTable.vue?vue&type=style&index=0&id=1cf53255&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports